import {
  CREATE_CONDITION_OF_ASSET_SUCCESS,
  FETCH_CONDITION_OF_ASSET_SUCCESS,
  GET_CONDITION_OF_ASSET_SUCCESS,
  SAVE_CONDITION_OF_ASSET_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_CONDITION_OF_ASSET_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_CONDITION_OF_ASSET_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_CONDITION_OF_ASSET_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_CONDITION_OF_ASSET_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
